const USER_ROLES_ENUM = Object.freeze({
    NORMAL: 0,
    REPRESENTATIVE: 1,
    REPRESENTATIVE_MANAGER: 2,
    OPERATION: 3,
    ADMINISTRATOR: 4,
    AUTOMATION: 5,
  });

export default USER_ROLES_ENUM;